export interface Backend {
  listen: Function;
  send: Function;
}
export interface ViewAsState {
  career: "mentor" | "mentee";
  readonly: boolean;
}
export interface OverviewState {
  // TODO: There is more to this object, not sure where
  yearIndex: number;
}
export interface CustomExportSettings {
  // TODO: More here?
  shown: boolean;
  dateLimited: boolean;
}

export namespace Section {
  export interface State {
    // TODO: look into this more
    acgme: object;
    career: object;
    career_0: object;
  }
}

export interface HierarchyNames {
  [key: string]: string;
}
export interface HierarchyDepartment {
  [key: string]: boolean | HierarchyDepartment;
}
export interface Hierarchy {
  [key: string]: {
    depts: {
      [key: string]: HierarchyDepartment;
    };
    hidden?: boolean;
  };
}
export interface TemplateList {
  [key: string]: {
    paths: string[];
  };
}
export interface SiteUpdateList {
  [key: string]: {
    date: number;
    id: string;
    paths: string[];
    text: string;
  };
}
export interface AccessPositions {
  app: boolean;
  faculty: boolean;
  fellow: boolean;
  resident: boolean;
  student: boolean;
  nonClinical: boolean;
}

export const allowedHTMLTagExpressions = [
  "<br>",
  "<br/>",
  "<br />",
  "<strong>",
  "</strong>",
  "<b>",
  "</b>",
  "<em>",
  "</em>",
  "<i>",
  "</i>",
  "<u>",
  "</u>",
  "<sub>",
  "</sub>",
  "<sup>",
  "</sup>",
  '<a href="[^>]*>',
  "<\\/a>"
];

export type LogLevel = "DEBUG" | "INFO" | "WARN" | "ERROR";

export type TimeObjectPoint =
  | {
      date: number | null;
      month: number | null;
      year: number | null;
    }
  | "ongoing";
export type TimeObject = {
  start?: TimeObjectPoint;
  end?: TimeObjectPoint;
};
export type EffortObject = {
  num: number;
  nominator: "hour" | string;
  per: "week" | "month" | "year";
};

export type DateAccuracy = "date" | "month" | "year";
